import React, { useState } from "react";
import { Autocomplete, TextField } from "@mui/material";

export const DataListComponent = ({ dataOptions }) => {
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  return (
    <Autocomplete
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": { borderColor: "black" }, // Color del borde normal
          "&:hover fieldset": { borderColor: "black" }, // Color al pasar el mouse
          "&.Mui-focused fieldset": { borderColor: "#ff6c0e" }, // Color cuando está enfocado
        },
        "& .MuiInputLabel-root": { color: "black" }, // Color del label
        "& .MuiInputLabel-root.Mui-focused": { color: "black" }, // Color del label cuando está enfocado
        "& .MuiInputLabel-root": {
          color: "#666", // Un gris oscuro para que no sea tan negro
          fontFamily: "pickers-light, sans-serif",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#666", // Un gris más claro cuando está enfocado
        },
      }}
      size="small"
      value={value}
      inputValue={inputValue} // Asegura que el valor ingresado se refleje en el input
      onChange={(event, newValue) => {
        setValue(newValue); // Actualiza el valor seleccionado
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue); // Actualiza el valor manual ingresado
      }}
      options={dataOptions}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.RespuestaTexto
      }
      renderOption={(props, option) => (
        <li {...props}>{option.RespuestaTexto}</li>
      )}
      freeSolo
      renderInput={(params) => (
        <TextField {...params} label="" />
      )}
    />
  );
};

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [{ title: "The Shawshank Redemption", year: 1994 }];
